export const A11Y_SPORTS_LIST_TEXT = "Now displaying the Olympics sports list";
export const SHOW_SPORTS = {
    ALL: "Show more sports",
    FEWER_SPORTS: "Show fewer sports",
};

export const SECTION_TITLES = {
    MOST_POPULAR: "Most Popular",
    ALL: "A to Z",
};
export const BUILD_MY_FEED = "Build My Feed";

const SPORTS_LISTS_BY_OLYMPICS = {
    SUMMER: {
        TRENDING_SPORTS: [
            "BASKETBALL",
            "ATHLETICS",
            "SOCCER",
            "SWIMMING",
            "TENNIS",
        ],
        ALL_SPORTS: [
            "ARCHERY",
            "ARTISTIC-SWIMMING",
            "BADMINTON",
            "3X3-BASKETBALL",
            "BEACH-VOLLEYBALL",
            "BOXING",
            "BREAKING",
            "CANOE-KAYAK",
            "CYCLING",
            "DIVING",
            "EQUESTRIAN",
            "FENCING",
            "FIELD-HOCKEY",
            "GOLF",
            "GYMNASTICS-ARTISTIC",
            "GYMNASTICS-RHYTHMIC",
            "GYMNASTICS-TRAMPOLINE",
            "HANDBALL",
            "JUDO",
            "MODERN-PENTATHLON",
            "ROWING",
            "RUGBY",
            "SAILING",
            "SHOOTING",
            "SKATEBOARDING",
            "SPORT-CLIMBING",
            "SURFING",
            "TABLE-TENNIS",
            "TAEKWONDO",
            "TRIATHLON",
            "VOLLEYBALL",
            "WATER-POLO",
            "WEIGHTLIFTING",
            "WRESTLING",
        ],
    },
    WINTER: {
        TRENDING_SPORTS: [
            "ALPINE_SKIING",
            "CURLING",
            "FIGURE_SKATING",
            "HOCKEY",
            "SPEED_SKATING",
        ],
        ALL_SPORTS: [
            "BIATHLON",
            "BOBSLEIGH",
            "CROSS_COUNTRY_SKIING",
            "FREESTYLE_SKIING",
            "LUGE",
            "NORDIC_COMBINED",
            "SHORT_TRACK_SPEED_SKATING",
            "SKELETON",
            "SKI_JUMPING",
            "SNOWBOARD",
        ],
    },
};

const SPORTS_BY_OLYMPICS = {
    SUMMER: {
        // summer
        "ARTISTIC-SWIMMING": {
            name: "Artistic Swimming",
            family: "artistic-swimming",
            path: "Sports/Sports names/Aquatics/Artistic swimming",
            categorySlug: "summer-olympics-artistic-swimming",
        },
        SWIMMING: {
            name: "Swimming",
            family: "swimming",
            path: "Sports/Sports names/Aquatics/Swimming",
            categorySlug: "summer-olympics-swimming",
        },
        ATHLETICS: {
            name: "Athletics",
            family: "athletics",
            path: "Sports/Sports names/Track and field",
            categorySlug: "track-and-field",
        },
        SOCCER: {
            name: "Soccer",
            family: "soccer",
            path: "Sports/Sports names/Soccer",
            categorySlug: "summer-olympics-soccer",
        },
        BASKETBALL: {
            name: "Basketball",
            family: "basketball",
            path: "Sports/Sports names/Basketball",
            categorySlug: "summer-olympics-basketball",
        },
        ARCHERY: {
            name: "Archery",
            family: "archery",
            path: "Sports/Sports names/Archery",
            categorySlug: "summer-olympics-archery",
        },
        BADMINTON: {
            name: "Badminton",
            family: "badminton",
            path: "Sports/Olympics/Summer Sports/Badminton",
            categorySlug: "badminton",
        },
        "3X3-BASKETBALL": {
            name: "3x3 Basketball",
            family: "basketball",
            path: "Sports/Sports names/Basketball",
            categorySlug: "3x3-basketball",
        },
        BOXING: {
            name: "Boxing",
            family: "boxing",
            path: "Sports/Sports names/Boxing",
            categorySlug: "summer-olympics-boxing",
        },
        BREAKING: {
            name: "Breaking",
            family: "breaking",
            path: "Sports/Sports names/Breaking",
            categorySlug: "olympics-summer-breaking",
        },
        "CANOE-KAYAK": {
            name: "Canoe",
            family: "canoe-kayak",
            path: "Sports/Sports names/Canoeing and kayaking",
            categorySlug: "summer-olympics-canoe-kayak",
        },
        CYCLING: {
            name: "Cycling",
            family: "cycling",
            path: "Sports/Sports names/Cycling",
            categorySlug: "summer-olympics-cycling",
        },
        DIVING: {
            name: "Diving",
            family: "diving",
            path: "Sports/Sports names/Aquatics/Diving",
            categorySlug: "summer-olympics-diving",
        },
        EQUESTRIAN: {
            name: "Equestrian",
            family: "equestrian",
            path: "Sports/Sports names/Equestrian",
            categorySlug: "summer-olympics-equestrian",
        },
        FENCING: {
            name: "Fencing",
            family: "fencing",
            path: "Sports/Sports names/Fencing",
            categorySlug: "summer-olympics-fencing",
        },
        "FIELD-HOCKEY": {
            name: "Field Hockey",
            family: "field-hockey",
            path: "Sports/Sports names/Field hockey",
            categorySlug: "summer-olympics-field-hockey",
        },
        GOLF: {
            name: "Golf",
            family: "golf",
            path: "Sports/Sports names/Golf",
            categorySlug: "summer-olympics-golf",
        },
        "GYMNASTICS-ARTISTIC": {
            name: "Gymnastics (Artistic)",
            family: "gymnastics",
            path: "Sports/Sports names/Gymnastics/Artistic gymnastics",
            categorySlug: "artistic",
        },
        "GYMNASTICS-RHYTHMIC": {
            name: "Gymnastics (Rhythmic)",
            family: "gymnastics",
            path: "Sports/Sports names/Gymnastics/Rhythmic gymnastics",
            categorySlug: "rhythmic",
        },
        "GYMNASTICS-TRAMPOLINE": {
            name: "Gymnastics (Trampoline)",
            family: "gymnastics",
            path: "Sports/Sports names/Gymnastics/Trampoline",
            categorySlug: "trampoline",
        },
        HANDBALL: {
            name: "Handball",
            family: "handball",
            path: "Sports/Sports names/Handball",
            categorySlug: "summer-olympics-handball",
        },
        JUDO: {
            name: "Judo",
            family: "judo",
            path: "Sports/Sports names/Martial arts/Judo",
            categorySlug: "summer-olympics-judo",
        },
        "MODERN-PENTATHLON": {
            name: "Modern Pentathlon",
            family: "modern-pentathlon",
            path: "Sports/Sports names/Modern pentathlon",
            categorySlug: "summer-olympics-modern-pentathlon",
        },
        ROWING: {
            name: "Rowing",
            family: "rowing",
            path: "Sports/Sports names/Rowing",
            categorySlug: "summer-olympics-rowing",
        },
        RUGBY: {
            name: "Rugby",
            family: "rugby",
            path: "Sports/Sports names/Rugby",
            categorySlug: "summer-olympics-rugby",
        },
        SAILING: {
            name: "Sailing",
            family: "sailing",
            path: "Sports/Sports names/Sailing",
            categorySlug: "summer-olympics-sailing",
        },
        SHOOTING: {
            name: "Shooting",
            family: "shooting",
            path: "Sports/Sports names/Shooting",
            categorySlug: "summer-olympics-shooting",
        },
        SKATEBOARDING: {
            name: "Skateboarding",
            family: "skateboarding",
            path: "Sports/Sports names/Skateboarding",
            categorySlug: "summer-olympics-skateboarding",
        },
        "SPORT-CLIMBING": {
            name: "Sport Climbing",
            family: "sport climbing",
            path: "Sports/Sports names/Climbing/Rock climbing/Sport climbing",
            categorySlug: "summer-olympics-sport-climbing",
        },
        SURFING: {
            name: "Surfing",
            family: "surfing",
            path: "Sports/Sports names/Surfing",
            categorySlug: "summer-olympics-surfing",
        },
        "TABLE-TENNIS": {
            name: "Table Tennis",
            family: "table-tennis",
            path: "Sports/Sports names/Table tennis",
            categorySlug: "summer-olympics-table-tennis",
        },
        TAEKWONDO: {
            name: "Taekwondo",
            family: "taekwondo",
            path: "Sports/Sports names/Martial arts/Taekwondo",
            categorySlug: "summer-olympics-taekwondo",
        },
        TENNIS: {
            name: "Tennis",
            family: "tennis",
            path: "Sports/Sports names/Tennis",
            categorySlug: "summer-olympics-tennis",
        },
        TRIATHLON: {
            name: "Triathlon",
            family: "triathlon",
            path: "Sports/Sports names/Triathlon",
            categorySlug: "summer-olympics-triathlon",
        },
        VOLLEYBALL: {
            name: "Volleyball",
            family: "volleyball",
            path: "Sports/Sports names/Volleyball games/Volleyball",
            categorySlug: "summer-olympics-volleyball",
        },
        "BEACH-VOLLEYBALL": {
            name: "Beach Volleyball",
            family: "beach-volleyball",
            path: "Sports/Sports names/Volleyball games/Beach volleyball",
            categorySlug: "summer-olympics-beach-volleyball",
        },
        "WATER-POLO": {
            name: "Water Polo",
            family: "water-polo",
            path: "Sports/Sports names/Water polo",
            categorySlug: "summer-olympics-water-polo",
        },
        WEIGHTLIFTING: {
            name: "Weightlifting",
            family: "weightlifting",
            path: "Sports/Sports names/Weightlifting",
            categorySlug: "summer-olympics-weightlifting",
        },
        WRESTLING: {
            name: "Wrestling",
            family: "wrestling",
            path: "Sports/Sports names/Wrestling",
            categorySlug: "summer-olympics-wrestling",
        },
    },

    WINTER: {
        ALPINE_SKIING: {
            name: "Alpine Skiing",
            family: "alpine-skiing",
            path: "Sports/Sports names/Skiing/Alpine skiing",
            categorySlug: "alpine-skiing",
        },
        BIATHLON: {
            name: "Biathlon",
            family: "biathlon",
            path: "Sports/Sports names/Biathlon",
            categorySlug: "winter-olympics-biathlon",
        },
        BOBSLEIGH: {
            name: "Bobsleigh",
            family: "bobsleigh",
            path: "Sports/Sports names/Bobsleigh",
            categorySlug: "bobsleigh",
        },
        CROSS_COUNTRY_SKIING: {
            name: "Cross-Country Skiing",
            family: "cross-country-skiing",
            path: "Sports/Sports names/Skiing/Nordic skiing/Cross-country skiing",
            categorySlug: "winter-olympics-cross-country-skiing",
        },
        CURLING: {
            name: "Curling",
            family: "curling",
            path: "Sports/Sports names/Curling",
            categorySlug: "curling",
        },
        FIGURE_SKATING: {
            name: "Figure Skating",
            family: "figure-skating",
            path: "Sports/Sports names/Skating/Figure skating",
            categorySlug: "figure-skating",
        },
        FREESTYLE_SKIING: {
            name: "Freestyle Skiing",
            family: "freestyle-skiing",
            path: "Sports/Sports names/Skiing/Freestyle skiing",
            categorySlug: "freestyle-skiing",
        },
        HOCKEY: {
            name: "Hockey",
            family: "hockey",
            path: "Sports/Sports names/Hockey",
            categorySlug: "winter-olympics-hockey",
        },
        LUGE: {
            name: "Luge",
            family: "luge",
            path: "Sports/Sports names/Luge",
            categorySlug: "winter-olympics-luge",
        },
        NORDIC_COMBINED: {
            name: "Nordic Combined",
            family: "nordic-combined",
            path: "Sports/Sports names/Skiing/Nordic skiing/Nordic combined",
            categorySlug: "winter-olympics-nordic-combined",
        },
        SHORT_TRACK_SPEED_SKATING: {
            name: "Short Track Speed Skating",
            family: "short-track-speed-skating",
            path: "Sports/Sports names/Skating/Short track speed skating",
            categorySlug: "winter-olympics-short-track-speed-skating",
        },
        SKELETON: {
            name: "Skeleton",
            family: "skeleton",
            path: "Sports/Sports names/Skeleton",
            categorySlug: "skeleton",
        },
        SKI_JUMPING: {
            name: "Ski Jumping",
            family: "ski-jumping",
            path: "Sports/Sports names/Skiing/Nordic skiing/Ski jumping",
            categorySlug: "ski-jumping",
        },
        SNOWBOARD: {
            name: "Snowboard",
            family: "snowboard",
            path: "Sports/Sports names/Snowboard",
            categorySlug: "winter-olympics-snowboard",
        },
        SPEED_SKATING: {
            name: "Speed Skating",
            family: "speed-skating",
            path: "Sports/Sports names/Skating/Speed skating",
            categorySlug: "winter-olympics-speed-skating",
        },
    },
};
const OLYMPICS = "SUMMER";
export const SPORTS_LISTS = SPORTS_LISTS_BY_OLYMPICS[OLYMPICS];
export const SPORTS = SPORTS_BY_OLYMPICS[OLYMPICS];
export const SPORTS_PREFERENCES = Object.keys(SPORTS);
